import LibraryShareContainer from '../../../containers/mailLibrary/libraryShareContainer';

export default function LibraryShare(props) {
  const { open, onClose, onShare } = props;
  return (
    <LibraryShareContainer open={open} onClose={onClose} onShare={onShare} />
  );
}
